import React, { useContext, useCallback, useEffect, useState } from "react";
import { StyleSheet, Text } from "react-native";
import { useHistory } from "react-router-dom";
import Row from "~/layouts/Row";
import Col from "~/layouts/Col";
import IconButton from "~/components/Buttons/IconButton";
import palette from "~/styles/palette";
import useParticipant from "~/hooks/useParticipant";
import ConversationContext from "~/contexts/ConversationContext";
import ParticipantContext from "~/contexts/ParticipantContext";
import useTwilio from "~/hooks/useTwilio";

export default function ParticipantActionBar() {
  const { participant, customer, loadingCustomer } =
    useContext(ParticipantContext);
  const { setParticipantFromCustomer, setParticipant, conversation } =
    useContext(ConversationContext);

  const [didPressText, setDidPressText] = useState(false);

  const { startCall, endCall, activeCall } = useTwilio();

  const history = useHistory();

  const phone_e164 = participant?.phone_e164 || customer?.phone_e164,
    phone = participant?.phone_number || customer?.phone,
    remote_id = participant?.remote_id, // || customer.id,
    email = participant?.email || customer?.email,
    first_name = participant?.first_name || customer?.first_name || "",
    last_name = participant?.last_name || customer?.last_name || "";

  const onEditCustomer = useCallback(() => {
    history.push({ hash: "edit-customer" }, { participant });
  }, [history, participant]);

  const onSavePress = useCallback(() => {
    history.push({ hash: "new-customer" }, { participant });
  }, [history, participant]);

  const onPhonePress = useCallback(() => {
    if (!activeCall) {
      startCall(phone_e164 || phone, {
        ...participant,
        name: `${first_name} ${last_name}`,
      });
    } else {
      endCall();
    }
  }, [
    phone_e164,
    phone,
    first_name,
    last_name,
    startCall,
    endCall,
    activeCall,
  ]);

  const onTextPress = useCallback(() => {
    if (participant?.id) {
      setParticipant(participant);
    } else {
      setParticipantFromCustomer(customer);
    }

    setDidPressText(true);
  }, [participant, customer, setParticipant, setParticipantFromCustomer]);

  useEffect(() => {
    if (didPressText && conversation?.id) {
      setDidPressText(false);

      history.push(`/messages/${conversation?.id}`);
    }
  }, [didPressText, conversation?.id]);

  return (
    <Row center pt={8} pb={16}>
      <Col size={1}></Col>
      <Col center maxWidth={85}>
        <IconButton
          iconName="phone"
          color={palette.primary_light}
          onPress={onPhonePress}
        />
        <Text style={[styles.participant_details_action_bar__label]}>Call</Text>
      </Col>
      <Col center maxWidth={85}>
        <IconButton
          iconName="message-circle"
          color={palette.primary_light}
          onPress={onTextPress}
        />
        <Text style={[styles.participant_details_action_bar__label]}>Text</Text>
      </Col>
      <Col center maxWidth={85}>
        <Text
          accessibilityRole={ !email ? undefined : "link" }
          href={!email ? undefined : `mailto:${email}`}
          style={styles.participant_email_action__link}
        >
          <IconButton iconName="mail" color={palette.primary_light} disabled={!email} />
          <Text style={[styles.participant_details_action_bar__label]}>
            Email
          </Text>
        </Text>
      </Col>
      {/* <Col center maxWidth={85}>
        <IconButton iconName="file-text" color={palette.primary_light} />
        <Text style={[styles.participant_details_action_bar__label]}>
          Invoice
        </Text>
      </Col> */}
      {/*       <Col center maxWidth={85}>
        <IconButton iconName="map" color={palette.primary_light} />
        <Text style={[styles.participant_details_action_bar__label]}>
          Map
        </Text>
      </Col> */}

      {!remote_id && (
        <Col center maxWidth={85}>
          <IconButton
            iconName="plus"
            color={palette.primary_light}
            onPress={onSavePress}
          />
          <Text style={[styles.participant_details_action_bar__label]}>
            Save
          </Text>
        </Col>
      )}

      {!!remote_id && (
        <Col center maxWidth={85}>
          <IconButton
            // disabled={loadingCustomer}
            iconName="edit"
            color={palette.primary_light}
            onPress={onEditCustomer}
          />
          <Text style={[styles.participant_details_action_bar__label]}>
            Edit
          </Text>
        </Col>
      )}

      <Col size={1}></Col>
    </Row>
  );
}

const styles = StyleSheet.create({
  participant_details_action_bar__label: {
    textAlign: "center",
    fontWeight: "500",
    paddingVertical: 6,
    fontSize: 12,
    color: palette.dark,
  },
  participant_email_action__link: {
    textDecoration: "none",
    textAlign: "center",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
});
